/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DuplicateSponsoredCompetitionBody
 */
export interface DuplicateSponsoredCompetitionBody {
    /**
     * Target month (1-12)
     * @type {number}
     * @memberof DuplicateSponsoredCompetitionBody
     */
    runningMonth: number;
    /**
     * Target year (2025+)
     * @type {number}
     * @memberof DuplicateSponsoredCompetitionBody
     */
    runningYear: number;
}

/**
 * Check if a given object implements the DuplicateSponsoredCompetitionBody interface.
 */
export function instanceOfDuplicateSponsoredCompetitionBody(value: object): value is DuplicateSponsoredCompetitionBody {
    if (!('runningMonth' in value) || value['runningMonth'] === undefined) return false;
    if (!('runningYear' in value) || value['runningYear'] === undefined) return false;
    return true;
}

export function DuplicateSponsoredCompetitionBodyFromJSON(json: any): DuplicateSponsoredCompetitionBody {
    return DuplicateSponsoredCompetitionBodyFromJSONTyped(json, false);
}

export function DuplicateSponsoredCompetitionBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DuplicateSponsoredCompetitionBody {
    if (json == null) {
        return json;
    }
    return {
        
        'runningMonth': json['runningMonth'],
        'runningYear': json['runningYear'],
    };
}

export function DuplicateSponsoredCompetitionBodyToJSON(json: any): DuplicateSponsoredCompetitionBody {
    return DuplicateSponsoredCompetitionBodyToJSONTyped(json, false);
}

export function DuplicateSponsoredCompetitionBodyToJSONTyped(value?: DuplicateSponsoredCompetitionBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'runningMonth': value['runningMonth'],
        'runningYear': value['runningYear'],
    };
}

